import { useContext } from 'react';
import { LabelsContext } from '../context/LabelsContext';

/**
 * const { t } = useLabels();
 * t('entity.debt.plural') -> deployment override ?? base label ?? the key itself.
 */
export const useLabels = () => useContext(LabelsContext);
